import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild, ViewChildren, ViewRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenStorage } from 'app/core/auth/_services/token-storage.service';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { LayoutUtilsService } from '../../../../../../core/_base/crud';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { DynamicSearchFormService } from '../../../../components/dynamic-search-form/dynamic-search-form.service';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { KeHoachSanXuatDataSource } from '../../../san-xuat/ke-hoach-san-xuat/ke-hoach-san-xuat-datasource/ke-hoach-san-xuat.datasource';
import { KeHoachSanXuat, KhKeHoachSanXuatInteraction } from '../../../san-xuat/ke-hoach-san-xuat/ke-hoach-san-xuat-model/ke-hoach-san-xuat.model';
import { ThongTinTonKhoTheoBOM } from '../bao-cao-chi-tiet-don-hang-ban-model/bao-cao-chi-tiet-don-hang-ban.model';
import { BaoCaoChiTietDonHangBanService } from '../bao-cao-chi-tiet-don-hang-ban-service/bao-cao-chi-tiet-don-hang-ban.service';
import { DungChungService } from './../../../dung-chung/__services/dung-chung.service';

@Component({
	selector: 'kt-bao-cao-chi-tiet-don-hang-ban-detail',
	templateUrl: './bao-cao-chi-tiet-don-hang-ban-detail.component.html',
	styleUrls: ['../bao-cao-chi-tiet-don-hang-ban.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})
export class BaoCaoChiTietDonHangBanDetailComponent implements OnInit {

	@ViewChild('reportTable', { static: true }) reportTable: ElementRef;
	@ViewChildren('focus') focus;

	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;

	/*--------------------Comment columns mat-table----------------------*/
	dataSource: KeHoachSanXuatDataSource;
	MainForm: FormGroup;

	/* --------------------------- Loading.... ---------------------------*/
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();

	/* ------------------------------ ROLE ------------------------------*/
	LIST_ROLES_USER: [] = [];

	/* ----------------------------- Filter ------------------------------*/
	haveFilter: boolean = true;
	filterGroupDataChecked: any = {};
	filterGroupDataCheckedFake: any = {};
	filterGroupData: any = {};
	filterGroupArray: any = {};
	filterText: any = {};
	tmpfilterText: any = {};
	disableButtonFilter: any = {};

	displayedColumns = [];
	availableColumns = [
		// {
		// 	stt: 1,
		// 	name: '#',
		// 	displayName: '#',
		// 	alwaysChecked: false,
		// 	isShow: true
		// },
		{
			stt: 2,
			name: 'MaHang',
			displayName: 'Mã hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'TenHang',
			displayName: 'Tên hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'SoLuong',
			displayName: 'Số lượng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'DVT',
			displayName: 'ĐVT',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'SoPO',
			displayName: 'Số PO',
			alwaysChecked: false,
			isShow: true
		},
	];


	/* ------------------------------Selection ---------------------------*/
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<any>(true, []);

	/*---------------------- Thông tin thao tác cho phiếu --------------- */
	listResult: KhKeHoachSanXuatInteraction[] = [];
	tmpListResult: any[] = [];

	/*------------------------ Danh sách ------------------*/
	listHH: any[] = [];
	selectHH = [];
	filteredHH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	HHFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */

	/*------------------------- Extend field: ----------------------------*/
	keywordssearch = '';
	previousIndex: number;
	fixedPoint = 2;
	disableButton: boolean = false;
	openDialog: boolean = false;
	keywordsearch: string = '';
	showDHB: boolean = false;
	IdHH: number = 0;
	IdCtDHB: number = 0;
	IdDHB: number = 0;

	isCreateXuatUuTien: boolean = false;
	isFromKH: boolean = false;
	dataPA: any;
	listNPLKH: any[] = [];
	/* ------------------------------------------------------------------*/

	constructor(
		public dialogRef: MatDialogRef<BaoCaoChiTietDonHangBanDetailComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dungChungServices: DungChungService,
		public dialog: MatDialog,
		private builder: FormBuilder,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private datePipe: DatePipe,
		private tokenStorage: TokenStorage,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private dynamicSearchFormService: DynamicSearchFormService,
		private services: BaoCaoChiTietDonHangBanService,
	) {
		let user = JSON.parse(localStorage.getItem("UserInfo"));
		this.LIST_ROLES_USER = user.roles;
	}

	/*---------------------------- LOAD DATA --------------------------------*/
	async ngOnInit() {
		;
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();

		this.ListThanhPham();
		this.createForm();

		this.showDHB = (this.data.IdCtDHB == undefined || this.data.IdCtDHB == null || this.data.IdCtDHB == 0) ? false : true;
		this.IdCtDHB = (this.data.IdCtDHB == undefined || this.data.IdCtDHB == null || this.data.IdCtDHB == 0) ? -1 : this.data.IdCtDHB;
		this.IdHH = (this.data.IdHH == undefined || this.data.IdHH == null) ? -1 : this.data.IdHH;
		this.isCreateXuatUuTien = (this.data.isCreateXuatUuTien == undefined ||  this.data.isCreateXuatUuTien == null) ? false : this.data.isCreateXuatUuTien;

		if(this.data.isFromKH){
			this.isFromKH = true;
			this.dataPA = this.data.dataPA
			if(this.dataPA)
				this.listNPLKH = this.dataPA._showListPANPL
		}

		this.LoadList(this.IdHH, this.IdCtDHB);

		this.MainForm.controls.HangHoa.setValue('' + this.IdHH);
		if (this.IdHH > 0)
			this.MainForm.controls.HangHoa.disable();
		if (this.showDHB) {
			this.services.getSoPhieuDHB(this.IdCtDHB).subscribe(res => {
				if (res && res.status == 1) {
					this.IdDHB = +res.data.Id;
					this.MainForm.controls.KdDatHangId.setValue(res.data.SoPhieu);
				}
			});
		}
		
		if(this.isCreateXuatUuTien){
			this.availableColumns.splice(0, 0, {
				stt: 0,
				name: 'select',
				displayName: 'Check chọn',
				alwaysChecked: true,
				isShow: true
			});
			this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		}
		this.showColumnsInTable();
		this.applySelectedColumns();

		this.changeDetectView();
	}
	/* -----------------------------------------------------------------------*/

	async LoadList(IdHH = 0, IdCtDHB = 0) {
		if (IdHH > -1) {
			let res = await this.services.listTonKhoHangHoaTheoBOM(IdHH).toPromise();
			if (IdCtDHB > -1)
				res = await this.services.listTonKhoHangHoaTheoBOM(IdHH, IdCtDHB).toPromise();
			if (res.status == 1 && res.data) {
				let headTP = new ThongTinTonKhoTheoBOM();
				headTP.MaHang = 'Thành phẩm';
				headTP.FlagHead = true;
				let headBTP = new ThongTinTonKhoTheoBOM();
				headBTP.MaHang = 'Bán thành phẩm';
				headBTP.FlagHead = true;
				let headNPL = new ThongTinTonKhoTheoBOM();
				headNPL.MaHang = 'Nguyên phụ liệu';
				headNPL.FlagHead = true;

				var first = [headTP].concat(res.data.filter(y => y.TypeHH == 0));
				var second = [headBTP].concat(res.data.filter(y => y.TypeHH == 1));
				var third = [headNPL].concat(res.data.filter(y => y.TypeHH == 2));
				this.tmpListResult = first.concat(second).concat(third);
			}
			this.tmpListResult = [...this.tmpListResult];
			console.log(JSON.stringify(this.tmpListResult));
			;
			if(this.tmpListResult.length > 0 && this.listNPLKH && this.listNPLKH.length > 0){
				this.listNPLKH.forEach(x => {
					let filterHH = this.tmpListResult.filter(y => y.IdHH == x.HhId && (this.dataPA.DhbId == y.IdPO || y.IdPO == null));
					let sum = 0;
					for(let k = 0; k < filterHH.length; k++){
						sum += filterHH[k].SoLuong;
					}
					if(sum < x.KlXuat){
						for(let k = 0; k < filterHH.length; k++){
							filterHH[k].isHighlight = true;
						}
					}
				})
			}
		}
		this.changeDetectView();
	}


	/*----------------- Create Form with appropriate sub forms ---------------*/
	createForm() {
		this.MainForm = this.builder.group({
			HangHoa: ['0'],
			KdDatHangId: [''],
		});
		this.MainForm.controls.KdDatHangId.disable();
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------- Hàm lấy danh sách-----------------------------*/
	async ListThanhPham() {
		let res = await this.services.listThanhPham().toPromise();
		if (res && res.status == 1) {
			this.listHH = res.data;
			this.filteredHH.next(this.listHH.slice());
			this.changeDetectView();
		}
	}
	filterHH() {
		if (!this.listHH) {
			return;
		}
		let search = this.HHFilterCtrl;
		if (!search) {
			this.filteredHH.next(this.listHH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredHH.next(
			this.listHH.filter(ts =>
				ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	changeHH(value: string) {
		if (this.tmpListResult.length > 0) {
			this.tmpListResult = [];
			this.tmpListResult = [...this.tmpListResult];
		}
		this.LoadList(+value);
		this.changeDetectView();
	}
	/*----------------------------------------------------------------------- */


	/*-------- CÁC HÀM HỖ TRỢ CHUYỂN CỘT VÀ HIỂN THỊ CỘT TRONG BẢNG ----------*/
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	/*----------------------------------------------------------------------- */


	/*----------------------- CÁC HÀM SỰ KIỆN FOCUS --------------------------*/
	forcusEvents() {
		this.openDialog = false;
		this.changeDetectView();
	}
	disabledDialog() {
		this.openDialog = true;
		this.changeDetectView();
	}
	checkDashboardRoute() {
		/* 
			Kiểm tra xem có phải đang ở dashboard không, nếu là trang dashboard thì không thực hiện
			các action trên component hiện tại.
		*/
		if (this.router.url === '/')
			return true;
		return false;
	}
	back() {
		this.dialogRef.close();
	}
	/* -----------------------------------------------------------------------*/


	/*-------------------- HÀM HỖ TRỢ FORMAT DẠNG SỐ -----------------------*/
	showErrorInputSL(columnName: string, formGroup: any, name: string) {
		let message = "";
		let controls = formGroup.controls;
		if (controls[columnName].value.length == 0 || this.formatComparenumber(controls[columnName].value) == 0) return name + ' là bắt buộc';
		if (controls[columnName].hasError('maxlength')
			|| (controls[columnName].value.length > 22
				&& (controls[columnName].value.indexOf(',') == 0 || controls[columnName].value.indexOf(',') > 21)))
			return 'Tối đa 18 chữ số với 2 chữ số thập phân';
		return message;
	}
	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == ',') {
					count += 1;
				}
			}
		}
		else {
			event = "" + event
			for (let i = 0; i < event.length; i++) {
				if (event[i] == ',') {
					count += 1;
				}
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		if (typeof (item) === "string") {
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	formatComparenumber(number: string) {
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER(item);
	}
	keyUpInputNumberVND(event) {
		FunctionPublic.preventAlphaV2(event);
	}
	changeInputNumberVND(event, columnName, min: number = 0, formGroup) {
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

			let data = FunctionPublic.slListChangedV2(event);
			if (data) {
				if (this.f_number(data) < min && event.data && event.data == '0') data = this.f_number((min));
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;

				if (data.length == 4) {
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}

			} else {
				controls[columnName].setValue(this.f_number((min)));
			}
		}
	}
	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup) {
		let controls = formGroup.controls;
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");

			if (Number(tmpValue) < min) tmpValue = min;

			if (!controls[controlName].invalid) {
				controls[controlName].setValue(
					this.f_number((tmpValue))
				);
			}
			if (tmpValue.indexOf(',') == 0 && tmpValue.length == 1) {
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_number((tmpValue))
			);
		}
		else {
			controls[controlName].setValue(this.f_number((min)));
		}
	}
	changeInputNumberVNDInList(event: any, min: number = 0) {

		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

			let data = FunctionPublic.slListChangedV2(event);
			console.log(data)
			if (data) {
				if (this.f_number(data) < min && event.data && event.data == '0') data = this.f_number(min);
				event.target.value = data;
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				if (data.length == 4) {
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}
			} else {
				event.target.value = this.f_number((min));
			}
		}
	}
	changeInputOfFormVNDInList(columnName: string, event: any, min: number = 0, item: any) {

		if (event.target.value == "") {
			event.target.value = this.f_number(0);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}

		if (event.target.value.toString() == item[columnName].toString()) {
			event.target.value = this.f_number(item[columnName]);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}

		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");

			if (Number(tmpValue) < min) tmpValue = min;

			if (!item[columnName]) {
				item[columnName] = tmpValue.toString();
			}

			if (tmpValue.toString().indexOf(',') == 0 && tmpValue.toString().length == 1) {
				tmpValue = min;
			}
			item[columnName] = tmpValue.toString();
		}
		else {
			item[columnName] = min.toString();
		}

		this.changeDetectView();
	}
	returnToPercent(inputNumber) {
		return inputNumber * 100;
	}
	roundNumber(input: number) {
		return Math.round(input)
	}
	/* -----------------------------------------------------------------------*/


	/*-------------------- HÀM HỖ TRỢ FORMAT DẠNG NGÀY -----------------------*/
	getFormatDate(v: string = '') {
		if (v != '' && v != null) {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	getFirstDay_LastDay(b_firstday) {
		var date = new Date(), y = date.getFullYear(), m = date.getMonth();
		var firstDay = new Date(y, m, 1);
		var lastDay = new Date(y, m + 1, 0);
		var curent = new Date();
		return b_firstday ? this.datePipe.transform(firstDay, 'dd/MM/yyyy') : this.datePipe.transform(curent, 'dd/MM/yyyy');
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------------ Extend Options --------------------------*/
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	scrollToBottom() {
		setTimeout(() => {
			window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
		}, 200);
	}
	getHeightCalendar(): any {
		let tmp_height = 0;
		tmp_height = window.innerHeight - 275;
		return tmp_height;
	}
	isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.tmpListResult.filter(x => !x.FlagHead && x.IdPO != this.IdDHB).length;
		return numSelected === numRows;
	}
	masterToggle() {
		if (this.isAllSelected()) {
			this.selection.clear();
		} else {
			this.tmpListResult.forEach((row, index) => {
				if(!row.FlagHead && row.IdPO != this.IdDHB){
					this.selection.select(row)
				}			
			});
		}
	}
	addXuatUuTien(){
		this.dialogRef.close();
		this.router.navigate(['de-nghi-uu-tien/them-moi', {}], {
			state: {
			  data: this.selection.selected
			}
		})
	}
	/* -----------------------------------------------------------------------*/
}
